export default __webpack_public_path__ + "static/media/video-home.bbbad701.webm";